import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/layout/Header";
import NavBar from "./components/layout/NavBar";
import Footer from "./components/layout/Footer";
import PageLayout from "./components/layout/PageLayout";
import ScrollToTop from "./components/layout/ScrollToTop";
import Hero from "./components/sections/Hero";
import About from "./components/sections/About";
import HowToBecomeVikar from "./components/sections/HowToBecomeVikar";
import ForVikarer from "./components/sections/ForVikarer";
import ForInstitutioner from "./components/sections/ForInstitutioner";
import VoresTilgang from "./components/sections/VoresTilgang";
import Contact from "./components/sections/Contact";
import CookieBanner from "./components/ui/CookieBanner";
import Privatlivspolitik from "./pages/Privatlivspolitik";
import Cookiepolitik from "./pages/Cookiepolitik";
import Servicevilkar from "./pages/Servicevilkar";
import Tilgaengelighed from "./pages/Tilgaengelighed";
import ForVikarerPage from "./pages/ForVikarerPage";
import ForInstitutionerPage from "./pages/ForInstitutionerPage";
import OmOsPage from "./pages/OmOsPage";
import KontaktPage from "./pages/KontaktPage";
import { initPixelsFromConsent } from "./utils/pixels";
import "./App.css";

function runSelfTests() {
  if (typeof window === "undefined") return;
  if (window.location.pathname !== "/") return;
  try {
    const hasHome = !!document.querySelector("#home");
    const hasAbout = !!document.querySelector("#about");
    const hasVikarer = !!document.querySelector("#vikarer");
    const hasInst = !!document.querySelector("#inst");
    const hasKontakt = !!document.querySelector("#kontakt");

    const heroImg = document.querySelector('img[data-hero-illustration="true"]');
    const logo = document.querySelector('[data-logo="true"]');
    const navLinks = Array.from(document.querySelectorAll("nav a"));

    const ok = hasHome && hasKontakt && !!heroImg;
    console.log("[Plejesøstrene self-test]", ok ? "PASS" : "FAIL", {
      hasHome,
      hasAbout,
      hasVikarer,
      hasInst,
      hasKontakt,
      hasHeroImage: !!heroImg,
      heroImageSrc: heroImg?.getAttribute("src") || null,
      heroImageSourceIndex: heroImg?.getAttribute("data-source-index") || null,
      hasLogo: !!logo,
      navCount: navLinks.length,
    });

    if (!hasHome) console.warn("[Test] Missing #home section");
    if (!hasKontakt) console.warn("[Test] Missing #kontakt section");
    if (navLinks.length < 4) console.warn("[Test] Expected >= 4 nav links");
  } catch (e) {
    console.warn("[Plejesøstrene self-test] ERROR", e);
  }
}

// Shared layout for legal/policy pages
function LegalPageLayout({ children }) {
  return (
    <>
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-lg border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-[4.5rem] md:h-20">
            <a href="/" className="flex items-center shrink-0">
              <img
                src="/logo/logo_landscape.svg"
                alt="Plejesøstrene ApS – logo"
                className="h-10 sm:h-12 md:h-14 w-auto"
                decoding="async"
              />
            </a>
            <a href="/" className="btn btn-ghost btn-sm">
              Tilbage til forsiden
            </a>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <Footer />
    </>
  );
}

// Main homepage component with all sections
function HomePage() {
  return (
    <>
      <Header />
      <NavBar />
      <Hero />
      <About />
      <ForVikarer />
      <HowToBecomeVikar />
      <ForInstitutioner />
      <VoresTilgang />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    setTimeout(runSelfTests, 0);
    // Initialize marketing pixels if user has already consented
    initPixelsFromConsent();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-white text-slate-900">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/for-vikarer" element={<PageLayout><ForVikarerPage /></PageLayout>} />
          <Route path="/for-institutioner" element={<PageLayout><ForInstitutionerPage /></PageLayout>} />
          <Route path="/om-os" element={<PageLayout><OmOsPage /></PageLayout>} />
          <Route path="/kontakt" element={<PageLayout><KontaktPage /></PageLayout>} />
          <Route path="/privatlivspolitik" element={<LegalPageLayout><Privatlivspolitik /></LegalPageLayout>} />
          <Route path="/cookiepolitik" element={<LegalPageLayout><Cookiepolitik /></LegalPageLayout>} />
          <Route path="/servicevilkar" element={<LegalPageLayout><Servicevilkar /></LegalPageLayout>} />
          <Route path="/tilgaengelighed" element={<LegalPageLayout><Tilgaengelighed /></LegalPageLayout>} />
        </Routes>
        <CookieBanner />
      </div>
    </BrowserRouter>
  );
}

export default App;
